<ul class="huron-breadcrumb">
  <li class="huron-breadcrumb-item" *ngFor="let item of breadcrumbList; let i = index">
    <ng-container>
      <a *ngIf="item.routeExists && i !== breadcrumbList.length - 1; else displayTextOnly;" [routerLink]="item.path">{{item.name}}</a>

      <ng-template #displayTextOnly>
        <span>{{item.name}}</span>
      </ng-template>

      <span class="huron-breadcrumb-item-divider">/</span>
    </ng-container>
  </li>
</ul>
